import { render, staticRenderFns } from "./ParticipantDeletedModal.vue?vue&type=template&id=97361cb8&scoped=true"
import script from "./ParticipantDeletedModal.vue?vue&type=script&lang=js"
export * from "./ParticipantDeletedModal.vue?vue&type=script&lang=js"
import style0 from "./ParticipantDeletedModal.vue?vue&type=style&index=0&id=97361cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97361cb8",
  null
  
)

export default component.exports